import { ExpenseItemCreatePage } from '@/features/expense-item/pages/ExpenseItemCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/expense-item/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["expense_item.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ExpenseItemCreatePage,
});
